
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";


const baseUrl = process.env.REACT_APP_API_URL;



export const CarrouselScreen = ({ titulo, producto }) => {
    return (
        <div style={styles.container}>
            <h2 style={styles.title}>{titulo}</h2>
            <div style={styles.carouselWrapper}>
                <Swiper
                    slidesPerView={5}
                    spaceBetween={10}
                    navigation={true}
                    slidesPerGroup={4}
                    autoplay={{ delay:7000, disableOnInteraction:false }}
                    breakpoints={{
                        "@0.00": { slidesPerView:2, spaceBetween:10 },
                        "@0.80": { slidesPerView:3, spaceBetween:10 },
                        "@1.10": { slidesPerView:4, spaceBetween:10 },
                        "@1.40": { slidesPerView: 5, spaceBetween: 10 },
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="netflix-swiper"
                >
                {producto?.map((produc) => (
                    <SwiperSlide key={produc.id}>
                    <Link to={`/detalle-producto/${produc.id}`} style={styles.cardLink} >
                        <div style={styles.card} className="netflix-card">
                        {produc.promocion && (
                            <div style={styles.promoBadge}>
                                <span style={styles.promoText}>PROMO</span>
                            </div>
                        )}
                        <img src={`${baseUrl}/uploads/productos/${produc.img}`}
                            alt={produc.nombre} style={styles.image}
                        />
                        <div style={styles.overlay} className="overlay">
                            <div style={styles.productName}>{produc.nombre}</div>
                        </div>
                        </div>
                    </Link>
                    </SwiperSlide>
                ))}
                </Swiper>
            </div>

            <style>{`
                .netflix-swiper {
                    padding: 20px 0;
                }

                .netflix-swiper .swiper-button-next,
                .netflix-swiper .swiper-button-prev {
                    color: #fff;
                    background: rgba(0, 0, 0, 0.7);
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .netflix-swiper:hover .swiper-button-next,
                .netflix-swiper:hover .swiper-button-prev {
                    opacity: 1;
                }

                .netflix-swiper .swiper-button-next:after,
                .netflix-swiper .swiper-button-prev:after {
                    font-size: 18px;
                }

                .netflix-card {
                    transition: transform 0.3s ease, z-index 0s 0.3s;
                }

                .netflix-card:hover {
                    transform: scale(1.15);
                    z-index: 10;
                    transition: transform 0.3s ease, z-index 0s;
                }

                .netflix-card:hover .overlay {
                    background: linear-gradient(to bottom, 
                    rgba(0, 0, 0, 0) 0%, 
                    rgba(0, 0, 0, 0.5) 60%, 
                    rgba(0, 0, 0, 0.9) 100%);
                }

                .netflix-card .overlay {
                    transition: background 0.3s ease;
                }
            `}</style>
        </div>
    );
};




const styles = {
    container: {
        width: '100%',
        padding: '40px 20px',
        backgroundColor: '#141414',
    },
    title: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#fff',
        paddingLeft: '10px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    carouselWrapper: {
        position: 'relative',
    },
    cardLink: {
        textDecoration: 'none',
        display: 'block',
    },
    card: {
        position: 'relative',
        width: '100%',
        aspectRatio: '4/5',
        borderRadius: '6px',
        overflow: 'hidden',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    },
    promoBadge: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: '#e50914',
        padding: '4px 10px',
        borderRadius: '4px',
        zIndex: 2,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.4)',
    },
    promoText: {
        color: '#fff',
        fontSize: '11px',
        fontWeight: '700',
        letterSpacing: '0.5px',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },
    overlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.7) 100%)',
        padding: '30px 12px 12px 12px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    productName: {
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: '1.3',
        textShadow: '0 1px 2px rgba(0, 0, 0, 1)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textAlign: 'center',
        width:'100%'
    },
};